import {
    RESET_QUALITY_INDICATOR,
    DISPLAY_CALL_SUSPENDED_ALERT,
    CLOSE_CALL_SUSPENDED_ALERT,
    CALL_SUSPENDED,
    CURRENT_ROOM_SUCCESS,
    CURRENT_ROOM_CLOSED,
    PICTURES_FETCH_SUCCESS,
    CLOSE_MESSAGE_SUCCESS,
    FETCH_CLOSURE_BY_CARE_GIVER,
    FETCH_PHOTO_SESSION,
    ERROR_DURING_CALL_LEAVING,
    START_CALL_LEAVING,
    PICTURE_DELETED,
    CLOSE_DELETED_MESSAGE,
    DOCUMENT_FETCH_SUCCESS,
    DOCUMENT_DELETED,
    DOCUMENT_REFRESH,
    CLOSE_DOCUMENT_MESSAGE,
    CLOSE_DELETED_DOCUMENT_MESSAGE,
    PICTURE_REORDERED,
} from '../actions/types'

interface CallStore {
    isSuspendedAlertDisplayed: boolean
    isSuspended: boolean
    isClosedByCareGiver: boolean
    isCareTakingPicture: boolean
    pictures: Array<any>
    documents: Array<any>
    openDocument: boolean
    openDeletedDocument: boolean
    openDeletedPicture: boolean
    open: boolean
    rtcStats: {
        quality: string
        biterateDown: string
        biterateUp: string
        packetsLossDown: string
        packetsLossUp: string
        dimensions: {
            width: string
            height: string
        }
        frameRate: string
    }
    isErrorDuringLeaving: boolean
    leavingCallStart: boolean
    hasSummary: boolean
}

const INITIAL_STATE: CallStore = {
    isSuspendedAlertDisplayed: false,
    isSuspended: false,
    isClosedByCareGiver: false,
    isCareTakingPicture: false,
    pictures: [],
    documents: [],
    openDocument: false,
    openDeletedDocument: false,
    openDeletedPicture: false,
    open: false,
    rtcStats: {
        quality: '',
        biterateDown: '',
        biterateUp: '',
        packetsLossDown: '',
        packetsLossUp: '',
        dimensions: {
            width: '',
            height: '',
        },
        frameRate: '',
    },
    isErrorDuringLeaving: false,
    leavingCallStart: false,
    hasSummary: false,
}

export default (state = INITIAL_STATE, action: any): CallStore => {
    switch (action.type) {
        case CURRENT_ROOM_SUCCESS:
            return {
                ...state,
                isSuspended: false,
                isErrorDuringLeaving: false,
                leavingCallStart: false,
            }
        case CURRENT_ROOM_CLOSED:
            return {
                ...state,
                ...INITIAL_STATE,
            }
        case PICTURES_FETCH_SUCCESS:
            return {
                ...state,
                pictures: action.payload,
                open: true,
            }
        case PICTURE_REORDERED:
            return {
                ...state,
                pictures: action.payload,
            }
        case DOCUMENT_FETCH_SUCCESS:
            return {
                ...state,
                documents: [action.payload, ...state.documents],
                openDocument: true,
            }
        case DOCUMENT_DELETED:
            return {
                ...state,
                documents: action.payload,
                openDeletedDocument: true,
            }
        case DOCUMENT_REFRESH:
            return {
                ...state,
                documents: action.payload,
            }
        case PICTURE_DELETED:
            return {
                ...state,
                pictures: action.payload,
                openDeletedPicture: true,
            }
        case CLOSE_DELETED_MESSAGE:
            return {
                ...state,
                openDeletedPicture: false,
            }
        case CLOSE_DOCUMENT_MESSAGE:
            return {
                ...state,
                openDocument: false,
            }
        case CLOSE_DELETED_DOCUMENT_MESSAGE:
            return {
                ...state,
                openDeletedDocument: false,
            }
        case CLOSE_MESSAGE_SUCCESS:
            return {
                ...state,
                open: false,
            }
        case RESET_QUALITY_INDICATOR:
            return {
                ...state,
                rtcStats: INITIAL_STATE.rtcStats,
            }
        case DISPLAY_CALL_SUSPENDED_ALERT:
            return {
                ...state,
                isSuspendedAlertDisplayed: true,
                isSuspended: true,
            }
        case CLOSE_CALL_SUSPENDED_ALERT:
            return {
                ...state,
                isSuspendedAlertDisplayed: false,
            }
        case CALL_SUSPENDED:
            return {
                ...state,
                isSuspended: true,
            }
        case FETCH_CLOSURE_BY_CARE_GIVER:
            return {
                ...state,
                isClosedByCareGiver: action.payload,
            }
        case FETCH_PHOTO_SESSION:
            return {
                ...state,
                isCareTakingPicture: action.payload,
            }
        case ERROR_DURING_CALL_LEAVING:
            return {
                ...state,
                isErrorDuringLeaving: true,
                leavingCallStart: false,
            }
        case START_CALL_LEAVING:
            return {
                ...state,
                leavingCallStart: true,
            }
        default:
            return state
    }
}
